import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import { CookieBanner } from "@/components/site/CookieBanner";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/privacy-policy" element={<Legal type="privacy" />} />
        <Route path="/cookie-policy" element={<Legal type="cookie" />} />
      </Routes>
      <CookieBanner />
      <Toaster position="bottom-left" theme="dark" />
    </BrowserRouter>
  );
}

export default App;
